/*
 * @Author: ZHANGJIAN
 * @Date: 2021-10-22 14:55:59
 * @LastEditTime: 2021-12-10 09:20:30
 * @LastEditors: ZHANGJIAN
 * @Description:
 */
var Store = {
  debug: true,
  state: {
    userInfo: {},
  },
  //设置用户信息
  SET_USERINFO(val) {
    this.state.userInfo = val;

    // this.state.message = newValue;
  },
  //获取缓存信息
  getters(key) {
    return this.state[key] || null;
  },
  actions: {
    //获取用户信息
    getUserInfo: function () {
      return new Promise((resolve, reject) => {
        Axios.post(
          "/gf/web/user/manage.do",
          {
            m: "getUserInfo",
            srt: 2,
            from: "web",
          },
          {
            headers: { requestBody: false },
          }
        ).then((res) => {
          if (res && res.code === "0") {
            resolve(res.obj || null);
          }
        });
      });
    },
    //获取游戏产品信息
    getProductList: function () {
      return new Promise((resolve, reject) => {
        let _self = this;
        Axios.post("/web/common/products").then((res) => {
          if (res && res.code === "0") {
            resolve(res.obj);
          }
        });
      });
    },
  },
};
console.log("Store内存缓存信息:", Store && Store.state);
